import { useFetch } from "@/hooks/useFetch";
import { getStyles } from "@/api/styles";
import type { Style } from "@/types/api";
import { event as gaEvent } from "@/lib/gtag";

const FALLBACK_COUPLES: Record<string, string> = {
  "classic-studio": "지수 & 민준",
  "luxury-editorial": "하은 & 도현",
  "monochrome-classic": "서연 & 준혁",
  "vintage-retro-film": "예진 & 태양",
  "indoor-lifestyle-engagement": "나연 & 성호",
  "garden-natural-outdoor": "수아 & 재원",
  "urban-travel-snap": "유진 & 시우",
  "sunset-waterside": "다인 & 현우",
  "veil-romance": "소율 & 지호",
};

export default function Portfolio() {
  const { data: styles } = useFetch(getStyles);

  const items = styles || [];

  return (
    <section id="portfolio" className="py-28 bg-[#FDFAF6]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.4em] uppercase mb-4 font-light">Portfolio</p>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-[#2D2D2D] mb-5">
            AI가 만든<br />
            <span className="italic">실제 웨딩 스냅</span>
          </h2>
          <p className="text-gray-500 text-sm font-light max-w-lg mx-auto leading-relaxed">
            모두 실제 고객의 사진을 기반으로 AI가 생성한 웨딩 스냅 사진입니다.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {items.map((style: Style, i: number) => (
            <div
              key={style.categoryKey}
              className={`relative group overflow-hidden rounded-2xl cursor-pointer ${i === 0 ? 'md:row-span-2' : ''}`}
            >
              <div className={`w-full ${i === 0 ? 'h-[520px]' : 'h-[260px]'} overflow-hidden bg-gray-100 flex items-center justify-center`}>
                {style.imageUrl ? (
                  <img
                    src={style.imageUrl}
                    alt={`${style.name} 웨딩 스냅`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    onError={(e) => { e.currentTarget.style.display = "none"; }}
                  />
                ) : (
                  <span className="text-gray-300 text-sm">{style.name}</span>
                )}
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="inline-block px-3 py-1 bg-[#C9A96E] text-white text-xs rounded-full mb-2 font-light">
                    {style.name}
                  </span>
                  <p className="text-white text-sm font-medium">
                    {FALLBACK_COUPLES[style.categoryKey] || ""}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => { gaEvent('click_cta', { location: 'portfolio', button: 'create_yours' }); window.REACT_APP_NAVIGATE('/login', { state: { from: '/order' } }); }}
            className="inline-flex items-center gap-2 px-10 py-4 bg-[#2D2D2D] text-white text-sm font-medium rounded-full hover:bg-[#444] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-camera-ai-line text-base"></i>
            나도 만들어보기
          </button>
        </div>
      </div>
    </section>
  );
}
